/* ============================================================
   DOSSHA Cart Upsell – Dynamic Recommendation Engine
   ============================================================ */

const DOSSHA_REC_MAP = {
  "ginchy-siyah-sort-tulum": [
    "ginchy-siyah-bra",
    "ginchy-siyah-atlet",
    "ginchy-siyah-tayt",
    "ginchy-siyah-tulum",
    "dossha-corap",
  ],
  "well-shaped-timeless-t-shirt": [
    "well-shaped-timeless-tayt",
    "well-shaped-timeless-bra",
    "well-shaped-power-bra",
    "well-shaped-power-tayt",
    "timeless-sac-bandi",
  ],
  "well-shaped-power-t-shirt": [
    "well-shaped-power-tayt",
    "well-shaped-power-bra",
    "well-shaped-timeless-bra",
    "well-shaped-timeless-tayt",
    "timeless-sac-bandi",
  ],
  "well-shaped-timeless-tayt": [
    "well-shaped-timeless-bra",
    "well-shaped-timeless-t-shirt",
    "well-shaped-power-bra",
    "timeless-sac-bandi",
    "dossha-shaker",
  ],
  "ginchy-lacivert-ince-askili-bra": [
    "ginchy-lacivert-tayt",
    "ginchy-lacivert-atlet",
    "ginchy-lacivert-bra",
    "noct-sac-bandi",
    "dossha-shaker",
  ],
  "ginchy-kahverengi-ince-askili-bra": [
    "ginchy-kahverengi-tayt",
    "ginchy-kahverengi-atlet",
    "ginchy-kahverengi-bra",
    "browny-sac-bandi",
    "dossha-shaker",
  ],
  "ginchy-siyah-ince-askili-bra": [
    "ginchy-siyah-tayt",
    "ginchy-siyah-bra",
    "ginchy-siyah-atlet",
    "ginchy-siyah-tulum",
    "timeless-sac-bandi",
  ],
  "it-girl-murdum-sort": [
    "it-girl-murdum-bra",
    "it-girl-murdum-burgu-bra",
    "it-girl-murdum-atlet",
    "it-girl-murdum-crop",
    "it-girl-murdum-tayt",
  ],
  "it-girl-antrasit-sort": [
    "it-girl-antrasit-bra",
    "it-girl-antrasit-burgu-bra",
    "it-girl-antrasit-atlet",
    "it-girl-antrasit-crop",
    "it-girl-antrasit-tayt",
  ],
  "it-girl-beyaz-sort": [
    "it-girl-beyaz-burgu-bra",
    "it-girl-beyaz-crop",
    "it-girl-beyaz-tisort",
    "dossha-sapka-hot-stuff",
    "dossha-corap",
  ],
  "it-girl-bordo-sort": [
    "it-girl-bordo-bra",
    "it-girl-bordo-burgu-bra",
    "it-girl-bordo-atlet",
    "it-girl-bordo-crop",
    "it-girl-bordo-tayt",
  ],
  "kapha-timeless-sort": [
    "kapha-timeless-crop",
    "kapha-noct-sort",
    "kapha-matcha-sort",
    "timeless-sac-bandi",
    "dossha-shaker",
  ],
  "kapha-matcha-sort": [
    "kapha-matcha-crop",
    "kapha-timeless-sort",
    "kapha-noct-sort",
    "timeless-sac-bandi",
    "dossha-corap",
  ],
  "well-shaped-timeless-bra": [
    "well-shaped-timeless-tayt",
    "well-shaped-timeless-t-shirt",
    "well-shaped-power-tayt",
    "timeless-sac-bandi",
    "dossha-shaker",
  ],
  "well-shaped-power-bra": [
    "well-shaped-power-tayt",
    "well-shaped-power-t-shirt",
    "well-shaped-timeless-tayt",
    "timeless-sac-bandi",
    "dossha-corap",
  ],
  "vata-calmness-tayt": [
    "vata-calmness-bra",
    "vata-calmness-ceket",
    "vata-baby-blue-tayt",
    "vata-power-bra",
    "timeless-sac-bandi",
  ],
  "vata-baby-blue-tayt": [
    "vata-baby-blue-bra",
    "vata-baby-blue-ceket",
    "vata-calmness-tayt",
    "vata-power-bra",
    "dossha-corap",
  ],
  "vata-power-tayt": [
    "vata-power-bra",
    "vata-power-ceket",
    "vata-calmness-tayt",
    "vata-baby-blue-bra",
    "dossha-shaker",
  ],
  "vata-calmness-ceket": [
    "vata-calmness-tayt",
    "vata-calmness-bra",
    "vata-power-ceket",
    "vata-baby-blue-ceket",
    "timeless-sac-bandi",
  ],
  "vata-baby-blue-ceket": [
    "vata-baby-blue-tayt",
    "vata-baby-blue-bra",
    "vata-calmness-ceket",
    "vata-power-ceket",
    "dossha-corap",
  ],
  "vata-calmness-bra": [
    "vata-calmness-tayt",
    "vata-calmness-ceket",
    "vata-power-bra",
    "vata-baby-blue-bra",
    "timeless-sac-bandi",
  ],
  "vata-baby-blue-bra": [
    "vata-baby-blue-tayt",
    "vata-baby-blue-ceket",
    "vata-calmness-bra",
    "vata-power-bra",
    "dossha-corap",
  ],
  "vata-power-bra": [
    "vata-power-tayt",
    "vata-power-ceket",
    "vata-calmness-bra",
    "vata-baby-blue-bra",
    "dossha-shaker",
  ],
  "pitta-royal-green-bra": [
    "pitta-royal-green-tayt",
    "pitta-siyah-tayt",
    "pitta-noct-bra",
    "pitta-balance-bra",
    "dossha-corap",
  ],
  "pitta-royal-green-tayt": [
    "pitta-royal-green-bra",
    "pitta-siyah-bra",
    "pitta-noct-tayt",
    "pitta-balance-tayt",
    "dossha-shaker",
  ],
  "it-girl-murdum-bra": [
    "it-girl-murdum-tayt",
    "it-girl-murdum-atlet",
    "it-girl-murdum-crop",
    "it-girl-murdum-sort",
    "it-girl-murdum-pantolon",
  ],
  "it-girl-antrasit-bra": [
    "it-girl-antrasit-tayt",
    "it-girl-antrasit-atlet",
    "it-girl-antrasit-crop",
    "it-girl-antrasit-sort",
    "it-girl-antrasit-pantolon",
  ],
  "it-girl-bordo-bra": [
    "it-girl-bordo-tayt",
    "it-girl-bordo-atlet",
    "it-girl-bordo-crop",
    "it-girl-bordo-sort",
    "it-girl-bordo-pantolon",
  ],
  "ginchy-lacivert-bra": [
    "ginchy-lacivert-tayt",
    "ginchy-lacivert-atlet",
    "ginchy-lacivert-ince-askili-bra",
    "noct-sac-bandi",
    "dossha-shaker",
  ],
  "ginchy-kahverengi-bra": [
    "ginchy-kahverengi-tayt",
    "ginchy-kahverengi-atlet",
    "ginchy-kahverengi-ince-askili-bra",
    "browny-sac-bandi",
    "dossha-corap",
  ],
  "ginchy-siyah-bra": [
    "ginchy-siyah-tayt",
    "ginchy-siyah-atlet",
    "ginchy-siyah-ince-askili-bra",
    "ginchy-siyah-tulum",
    "timeless-sac-bandi",
  ],
  "timeless-sac-bandi": [
    "well-shaped-timeless-tayt",
    "kapha-timeless-sort",
    "well-shaped-timeless-bra",
    "vata-calmness-tayt",
    "dossha-shaker",
  ],
  "browny-sac-bandi": [
    "ginchy-kahverengi-tayt",
    "ginchy-kahverengi-bra",
    "kapha-browny-sort",
    "kapha-browny-crop",
    "dossha-shaker",
  ],
  "noct-sac-bandi": [
    "pitta-noct-tayt",
    "pitta-noct-bra",
    "kapha-noct-sort",
    "kapha-noct-crop",
    "dossha-corap",
  ],
  "cherry-berry-sac-bandi": [
    "pitta-cherry-berry-tayt",
    "pitta-cherry-berry-bra",
    "kapha-cherry-berry-sort",
    "kapha-cherry-berry-crop",
    "dossha-shaker",
  ],
  "dossha-shaker": [
    "dossha-corap",
    "dossha-termos-600-ml",
    "dossha-sapka-hot-stuff",
    "timeless-sac-bandi",
    "aura-siyah-sac-bandi",
  ],
  "dossha-corap": [
    "dossha-shaker",
    "dossha-termos-600-ml",
    "dossha-kisa-corap",
    "timeless-sac-bandi",
    "ginchy-siyah-tayt",
  ],
  "ginchy-lacivert-atlet": [
    "ginchy-lacivert-tayt",
    "ginchy-lacivert-bra",
    "ginchy-lacivert-ince-askili-bra",
    "noct-sac-bandi",
    "dossha-shaker",
  ],
  "ginchy-kahverengi-atlet": [
    "ginchy-kahverengi-tayt",
    "ginchy-kahverengi-bra",
    "ginchy-kahverengi-ince-askili-bra",
    "browny-sac-bandi",
    "dossha-shaker",
  ],
  "ginchy-siyah-atlet": [
    "ginchy-siyah-tayt",
    "ginchy-siyah-bra",
    "ginchy-siyah-ince-askili-bra",
    "timeless-sac-bandi",
    "ginchy-siyah-tulum",
  ],
  "it-girl-murdum-atlet": [
    "it-girl-murdum-tayt",
    "it-girl-murdum-bra",
    "it-girl-murdum-crop",
    "it-girl-murdum-sort",
    "it-girl-murdum-pantolon",
  ],
  "it-girl-antrasit-atlet": [
    "it-girl-antrasit-tayt",
    "it-girl-antrasit-bra",
    "it-girl-antrasit-crop",
    "it-girl-antrasit-sort",
    "it-girl-antrasit-pantolon",
  ],
  "it-girl-bordo-atlet": [
    "it-girl-bordo-tayt",
    "it-girl-bordo-bra",
    "it-girl-bordo-crop",
    "it-girl-bordo-sort",
    "it-girl-bordo-pantolon",
  ],
  "it-girl-murdum-burgu-bra": [
    "it-girl-murdum-tayt",
    "it-girl-murdum-atlet",
    "it-girl-murdum-crop",
    "it-girl-murdum-sort",
    "it-girl-murdum-pantolon",
  ],
  "it-girl-antrasit-burgu-bra": [
    "it-girl-antrasit-tayt",
    "it-girl-antrasit-atlet",
    "it-girl-antrasit-crop",
    "it-girl-antrasit-sort",
    "it-girl-antrasit-pantolon",
  ],
  "it-girl-beyaz-burgu-bra": [
    "it-girl-beyaz-crop",
    "it-girl-beyaz-tisort",
    "it-girl-beyaz-sort",
    "dossha-sapka-ciao-amore",
    "dossha-corap",
  ],
  "it-girl-bordo-burgu-bra": [
    "it-girl-bordo-tayt",
    "it-girl-bordo-atlet",
    "it-girl-bordo-crop",
    "it-girl-bordo-sort",
    "it-girl-bordo-pantolon",
  ],
  "vata-power-ceket": [
    "vata-power-tayt",
    "vata-power-bra",
    "vata-calmness-ceket",
    "vata-baby-blue-ceket",
    "timeless-sac-bandi",
  ],
  "it-girl-murdum-crop": [
    "it-girl-murdum-tayt",
    "it-girl-murdum-bra",
    "it-girl-murdum-atlet",
    "it-girl-murdum-sort",
    "it-girl-murdum-pantolon",
  ],
  "it-girl-antrasit-crop": [
    "it-girl-antrasit-tayt",
    "it-girl-antrasit-bra",
    "it-girl-antrasit-atlet",
    "it-girl-antrasit-sort",
    "it-girl-antrasit-pantolon",
  ],
  "it-girl-beyaz-crop": [
    "it-girl-beyaz-burgu-bra",
    "it-girl-beyaz-tisort",
    "it-girl-beyaz-sort",
    "dossha-sapka-hot-stuff",
    "dossha-corap",
  ],
  "it-girl-bordo-crop": [
    "it-girl-bordo-tayt",
    "it-girl-bordo-bra",
    "it-girl-bordo-atlet",
    "it-girl-bordo-sort",
    "it-girl-bordo-pantolon",
  ],
  "ginchy-siyah-tayt": [
    "ginchy-siyah-bra",
    "ginchy-siyah-atlet",
    "ginchy-siyah-ince-askili-bra",
    "ginchy-siyah-tulum",
    "timeless-sac-bandi",
  ],
  "it-girl-bordo-pantolon": [
    "it-girl-bordo-bra",
    "it-girl-bordo-atlet",
    "it-girl-bordo-crop",
    "it-girl-bordo-tayt",
    "it-girl-bordo-sort",
  ],
  "it-girl-antrasit-pantolon": [
    "it-girl-antrasit-bra",
    "it-girl-antrasit-atlet",
    "it-girl-antrasit-crop",
    "it-girl-antrasit-tayt",
    "it-girl-antrasit-sort",
  ],
  "it-girl-beyaz-tisort": [
    "it-girl-beyaz-sort",
    "it-girl-beyaz-burgu-bra",
    "it-girl-beyaz-crop",
    "dossha-sapka-ciao-amore",
    "dossha-corap",
  ],
  "kapha-timeless-crop": [
    "kapha-timeless-sort",
    "kapha-matcha-crop",
    "kapha-noct-crop",
    "timeless-sac-bandi",
    "dossha-shaker",
  ],
  "kapha-noct-crop": [
    "kapha-noct-sort",
    "noct-sac-bandi",
    "kapha-timeless-crop",
    "pitta-noct-tayt",
    "dossha-corap",
  ],
  "kapha-browny-crop": [
    "kapha-browny-sort",
    "browny-sac-bandi",
    "kapha-timeless-crop",
    "ginchy-kahverengi-tayt",
    "dossha-shaker",
  ],
  "kapha-matcha-crop": [
    "kapha-matcha-sort",
    "kapha-timeless-crop",
    "kapha-noct-crop",
    "timeless-sac-bandi",
    "dossha-corap",
  ],
  "kapha-noct-sort": [
    "kapha-noct-crop",
    "noct-sac-bandi",
    "kapha-timeless-sort",
    "pitta-noct-bra",
    "dossha-shaker",
  ],
  "kapha-browny-sort": [
    "kapha-browny-crop",
    "browny-sac-bandi",
    "kapha-timeless-sort",
    "ginchy-kahverengi-bra",
    "dossha-corap",
  ],
  "kapha-cherry-berry-crop": [
    "kapha-cherry-berry-sort",
    "cherry-berry-sac-bandi",
    "kapha-timeless-crop",
    "pitta-cherry-berry-tayt",
    "dossha-shaker",
  ],
  "kapha-cherry-berry-sort": [
    "kapha-cherry-berry-crop",
    "cherry-berry-sac-bandi",
    "kapha-timeless-sort",
    "pitta-cherry-berry-bra",
    "dossha-corap",
  ],
  "pitta-siyah-bra": [
    "pitta-siyah-tayt",
    "pitta-royal-green-tayt",
    "pitta-noct-bra",
    "dossha-shaker",
    "dossha-corap",
  ],
  "pitta-cherry-berry-bra": [
    "pitta-cherry-berry-tayt",
    "cherry-berry-sac-bandi",
    "kapha-cherry-berry-sort",
    "pitta-siyah-tayt",
    "dossha-shaker",
  ],
  "pitta-siyah-tayt": [
    "pitta-siyah-bra",
    "pitta-royal-green-bra",
    "pitta-noct-tayt",
    "dossha-shaker",
    "dossha-corap",
  ],
  "pitta-cherry-berry-tayt": [
    "pitta-cherry-berry-bra",
    "cherry-berry-sac-bandi",
    "kapha-cherry-berry-crop",
    "pitta-siyah-bra",
    "dossha-shaker",
  ],
  "it-girl-murdum-pantolon": [
    "it-girl-murdum-bra",
    "it-girl-murdum-atlet",
    "it-girl-murdum-crop",
    "it-girl-murdum-tayt",
    "it-girl-murdum-sort",
  ],
  "pitta-baby-pink-bra": [
    "pitta-baby-pink-tayt",
    "pitta-balance-bra",
    "pitta-ripe-bra",
    "pitta-siyah-tayt",
    "dossha-corap",
  ],
  "pitta-balance-bra": [
    "pitta-balance-tayt",
    "pitta-baby-pink-bra",
    "pitta-noct-bra",
    "pitta-siyah-tayt",
    "dossha-shaker",
  ],
  "pitta-ripe-bra": [
    "pitta-ripe-tayt",
    "pitta-balance-bra",
    "pitta-cherry-berry-bra",
    "pitta-siyah-tayt",
    "dossha-corap",
  ],
  "pitta-noct-bra": [
    "pitta-noct-tayt",
    "noct-sac-bandi",
    "kapha-noct-sort",
    "pitta-siyah-tayt",
    "dossha-shaker",
  ],
  "pitta-baby-pink-tayt": [
    "pitta-baby-pink-bra",
    "pitta-balance-tayt",
    "pitta-ripe-tayt",
    "pitta-siyah-bra",
    "dossha-shaker",
  ],
  "pitta-balance-tayt": [
    "pitta-balance-bra",
    "pitta-baby-pink-tayt",
    "pitta-noct-tayt",
    "pitta-siyah-bra",
    "dossha-corap",
  ],
  "pitta-ripe-tayt": [
    "pitta-ripe-bra",
    "pitta-balance-tayt",
    "pitta-cherry-berry-tayt",
    "pitta-siyah-bra",
    "dossha-shaker",
  ],
  "sweatshirt-gri": [
    "loungewear-gri-melanj-jogger",
    "loungewear-gri-melanj-hoodie",
    "loungewear-gri-melanj-wide-leg-esofman",
    "dossha-sapka-hot-stuff",
    "dossha-corap",
  ],
  "sweatshirt-ekru": [
    "loungewear-ekru-jogger",
    "loungewear-ekru-sweatshirt",
    "loungewear-dossha-ekru-sort",
    "loungewear-dossha-ekru-crop-tisort",
    "dossha-shaker",
  ],
  "it-girl-bordo-tayt": [
    "it-girl-bordo-bra",
    "it-girl-bordo-atlet",
    "it-girl-bordo-crop",
    "it-girl-bordo-sort",
    "it-girl-bordo-pantolon",
  ],
  "it-girl-antrasit-tayt": [
    "it-girl-antrasit-bra",
    "it-girl-antrasit-atlet",
    "it-girl-antrasit-crop",
    "it-girl-antrasit-sort",
    "it-girl-antrasit-pantolon",
  ],
  "ginchy-lacivert-tayt": [
    "ginchy-lacivert-bra",
    "ginchy-lacivert-atlet",
    "ginchy-lacivert-ince-askili-bra",
    "noct-sac-bandi",
    "dossha-shaker",
  ],
  "ginchy-kahverengi-tayt": [
    "ginchy-kahverengi-bra",
    "ginchy-kahverengi-atlet",
    "ginchy-kahverengi-ince-askili-bra",
    "browny-sac-bandi",
    "dossha-corap",
  ],
  "it-girl-murdum-tayt": [
    "it-girl-murdum-bra",
    "it-girl-murdum-atlet",
    "it-girl-murdum-crop",
    "it-girl-murdum-sort",
    "it-girl-murdum-pantolon",
  ],
  "pitta-noct-tayt": [
    "pitta-noct-bra",
    "noct-sac-bandi",
    "kapha-noct-sort",
    "pitta-siyah-bra",
    "dossha-shaker",
  ],
  "well-shaped-power-tayt": [
    "well-shaped-power-bra",
    "well-shaped-power-t-shirt",
    "well-shaped-timeless-tayt",
    "timeless-sac-bandi",
    "dossha-corap",
  ],
  "ginchy-siyah-tulum": [
    "ginchy-siyah-bra",
    "ginchy-siyah-atlet",
    "ginchy-siyah-tayt",
    "ginchy-siyah-ince-askili-bra",
    "timeless-sac-bandi",
  ],
  "it-girl-baby-blue-burgu-bra": [
    "it-girl-baby-blue-tayt",
    "it-girl-baby-blue-bra",
    "it-girl-baby-blue-ceket",
    "it-girl-baby-blue-crop",
    "it-girl-baby-blue-sort",
  ],
  "it-girl-baby-blue-tayt": [
    "it-girl-baby-blue-bra",
    "it-girl-baby-blue-burgu-bra",
    "it-girl-baby-blue-ceket",
    "it-girl-baby-blue-crop",
    "it-girl-baby-blue-sort",
  ],
  "it-girl-baby-blue-crop": [
    "it-girl-baby-blue-tayt",
    "it-girl-baby-blue-bra",
    "it-girl-baby-blue-ceket",
    "it-girl-baby-blue-sort",
    "it-girl-baby-blue-burgu-bra",
  ],
  "it-girl-baby-blue-ceket": [
    "it-girl-baby-blue-tayt",
    "it-girl-baby-blue-bra",
    "it-girl-baby-blue-crop",
    "it-girl-baby-blue-sort",
    "it-girl-baby-blue-burgu-bra",
  ],
  "it-girl-baby-blue-sort": [
    "it-girl-baby-blue-tayt",
    "it-girl-baby-blue-bra",
    "it-girl-baby-blue-ceket",
    "it-girl-baby-blue-crop",
    "it-girl-baby-blue-burgu-bra",
  ],
  "it-girl-butter-yellow-burgu-bra": [
    "it-girl-butter-yellow-tayt",
    "it-girl-butter-yellow-bra",
    "it-girl-butter-yellow-ceket",
    "it-girl-butter-yellow-crop",
    "it-girl-butter-yellow-sort",
  ],
  "it-girl-butter-yellow-tayt": [
    "it-girl-butter-yellow-bra",
    "it-girl-butter-yellow-burgu-bra",
    "it-girl-butter-yellow-ceket",
    "it-girl-butter-yellow-crop",
    "it-girl-butter-yellow-sort",
  ],
  "it-girl-butter-yellow-crop": [
    "it-girl-butter-yellow-tayt",
    "it-girl-butter-yellow-bra",
    "it-girl-butter-yellow-ceket",
    "it-girl-butter-yellow-sort",
    "it-girl-butter-yellow-burgu-bra",
  ],
  "it-girl-butter-yellow-ceket": [
    "it-girl-butter-yellow-tayt",
    "it-girl-butter-yellow-bra",
    "it-girl-butter-yellow-crop",
    "it-girl-butter-yellow-sort",
    "it-girl-butter-yellow-burgu-bra",
  ],
  "it-girl-butter-yellow-sort": [
    "it-girl-butter-yellow-tayt",
    "it-girl-butter-yellow-bra",
    "it-girl-butter-yellow-ceket",
    "it-girl-butter-yellow-crop",
    "it-girl-butter-yellow-burgu-bra",
  ],
  "it-girl-siyah-burgu-bra": [
    "it-girl-siyah-crop",
    "it-girl-siyah-sort",
    "ginchy-siyah-tayt",
    "aura-siyah-ceket",
    "dossha-corap",
  ],
  "it-girl-siyah-crop": [
    "it-girl-siyah-burgu-bra",
    "it-girl-siyah-sort",
    "ginchy-siyah-tayt",
    "aura-siyah-atlet",
    "dossha-shaker",
  ],
  "it-girl-siyah-sort": [
    "it-girl-siyah-burgu-bra",
    "it-girl-siyah-crop",
    "ginchy-siyah-tulum",
    "aura-siyah-bra",
    "dossha-corap",
  ],
  "dossha-sapka-ciao-amore": [
    "dossha-termos-600-ml",
    "dossha-shaker",
    "it-girl-beyaz-tisort",
    "court-kiss-beyaz-elbise",
    "dossha-corap",
  ],
  "dossha-sapka-hot-stuff": [
    "dossha-termos-600-ml",
    "dossha-shaker",
    "it-girl-siyah-sort",
    "aura-siyah-ceket",
    "dossha-corap",
  ],
  "it-girl-baby-blue-bra": [
    "it-girl-baby-blue-tayt",
    "it-girl-baby-blue-ceket",
    "it-girl-baby-blue-crop",
    "it-girl-baby-blue-sort",
    "it-girl-baby-blue-burgu-bra",
  ],
  "it-girl-butter-yellow-bra": [
    "it-girl-butter-yellow-tayt",
    "it-girl-butter-yellow-ceket",
    "it-girl-butter-yellow-crop",
    "it-girl-butter-yellow-sort",
    "it-girl-butter-yellow-burgu-bra",
  ],
  "eternal-bloom-siyah-atlet": [
    "eternal-bloom-siyah-tayt",
    "eternal-bloom-siyah-bra",
    "eternal-bloom-siyah-buzgulu-bra",
    "eternal-bloom-siyah-sort",
    "eternal-bloom-siyah-baglama-bolero",
  ],
  "eternal-bloom-kahverengi-atlet": [
    "eternal-bloom-kahverengi-tayt",
    "eternal-bloom-kahverengi-bra",
    "eternal-bloom-kahverengi-buzgulu-bra",
    "eternal-bloom-kahverengi-sort",
    "eternal-bloom-kahverengi-baglama-bolero",
  ],
  "eternal-bloom-gul-kurusu-atlet": [
    "eternal-bloom-gul-kurusu-tayt",
    "eternal-bloom-gul-kurusu-bra",
    "eternal-bloom-gul-kurusu-buzgulu-bra",
    "eternal-bloom-gul-kurusu-sort",
    "eternal-bloom-gul-kurusu-baglama-bolero",
  ],
  "eternal-bloom-yesil-atlet": [
    "eternal-bloom-yesil-tayt",
    "eternal-bloom-yesil-bra",
    "eternal-bloom-yesil-buzgulu-bra",
    "eternal-bloom-yesil-sort",
    "eternal-bloom-yesil-sirt-dekolte-tulum",
  ],
  "eternal-bloom-beyaz-atlet": [
    "eternal-bloom-beyaz-bra",
    "eternal-bloom-beyaz-buzgulu-bra",
    "eternal-bloom-ekru-baglama-bolero",
    "loungewear-beyaz-hoodie",
    "dossha-shaker",
  ],
  "eternal-bloom-siyah-bra": [
    "eternal-bloom-siyah-tayt",
    "eternal-bloom-siyah-atlet",
    "eternal-bloom-siyah-buzgulu-bra",
    "eternal-bloom-siyah-sort",
    "eternal-bloom-siyah-baglama-bolero",
  ],
  "eternal-bloom-kahverengi-bra": [
    "eternal-bloom-kahverengi-tayt",
    "eternal-bloom-kahverengi-atlet",
    "eternal-bloom-kahverengi-buzgulu-bra",
    "eternal-bloom-kahverengi-sort",
    "eternal-bloom-kahverengi-baglama-bolero",
  ],
  "eternal-bloom-gul-kurusu-bra": [
    "eternal-bloom-gul-kurusu-tayt",
    "eternal-bloom-gul-kurusu-atlet",
    "eternal-bloom-gul-kurusu-buzgulu-bra",
    "eternal-bloom-gul-kurusu-sort",
    "eternal-bloom-gul-kurusu-baglama-bolero",
  ],
  "eternal-bloom-yesil-bra": [
    "eternal-bloom-yesil-tayt",
    "eternal-bloom-yesil-atlet",
    "eternal-bloom-yesil-buzgulu-bra",
    "eternal-bloom-yesil-sort",
    "eternal-bloom-yesil-sirt-dekolte-tulum",
  ],
  "eternal-bloom-beyaz-bra": [
    "eternal-bloom-beyaz-atlet",
    "eternal-bloom-beyaz-buzgulu-bra",
    "eternal-bloom-ekru-baglama-bolero",
    "loungewear-beyaz-wide-leg-esofman",
    "dossha-corap",
  ],
  "eternal-bloom-siyah-buzgulu-bra": [
    "eternal-bloom-siyah-tayt",
    "eternal-bloom-siyah-bra",
    "eternal-bloom-siyah-atlet",
    "eternal-bloom-siyah-sort",
    "eternal-bloom-siyah-baglama-bolero",
  ],
  "eternal-bloom-kahverengi-buzgulu-bra": [
    "eternal-bloom-kahverengi-tayt",
    "eternal-bloom-kahverengi-bra",
    "eternal-bloom-kahverengi-atlet",
    "eternal-bloom-kahverengi-sort",
    "eternal-bloom-kahverengi-baglama-bolero",
  ],
  "eternal-bloom-gul-kurusu-buzgulu-bra": [
    "eternal-bloom-gul-kurusu-tayt",
    "eternal-bloom-gul-kurusu-bra",
    "eternal-bloom-gul-kurusu-atlet",
    "eternal-bloom-gul-kurusu-sort",
    "eternal-bloom-gul-kurusu-baglama-bolero",
  ],
  "eternal-bloom-yesil-buzgulu-bra": [
    "eternal-bloom-yesil-tayt",
    "eternal-bloom-yesil-bra",
    "eternal-bloom-yesil-atlet",
    "eternal-bloom-yesil-sort",
    "eternal-bloom-yesil-sirt-dekolte-tulum",
  ],
  "eternal-bloom-beyaz-buzgulu-bra": [
    "eternal-bloom-beyaz-bra",
    "eternal-bloom-beyaz-atlet",
    "eternal-bloom-ekru-baglama-bolero",
    "loungewear-beyaz-hoodie",
    "dossha-shaker",
  ],
  "eternal-bloom-siyah-fermuar-tulum": [
    "eternal-bloom-siyah-tayt",
    "eternal-bloom-siyah-bra",
    "eternal-bloom-siyah-atlet",
    "eternal-bloom-siyah-baglama-bolero",
    "dossha-corap",
  ],
  "eternal-bloom-kahverengi-fermuar-tulum": [
    "eternal-bloom-kahverengi-tayt",
    "eternal-bloom-kahverengi-bra",
    "eternal-bloom-kahverengi-atlet",
    "eternal-bloom-kahverengi-baglama-bolero",
    "dossha-shaker",
  ],
  "eternal-bloom-gul-kurusu-sirt-dekolte-tulum": [
    "eternal-bloom-gul-kurusu-tayt",
    "eternal-bloom-gul-kurusu-bra",
    "eternal-bloom-gul-kurusu-atlet",
    "eternal-bloom-gul-kurusu-baglama-bolero",
    "dossha-corap",
  ],
  "eternal-bloom-yesil-sirt-dekolte-tulum": [
    "eternal-bloom-yesil-tayt",
    "eternal-bloom-yesil-bra",
    "eternal-bloom-yesil-atlet",
    "eternal-bloom-yesil-sort",
    "dossha-shaker",
  ],
  "eternal-bloom-siyah-tayt": [
    "eternal-bloom-siyah-bra",
    "eternal-bloom-siyah-atlet",
    "eternal-bloom-siyah-buzgulu-bra",
    "eternal-bloom-siyah-sort",
    "eternal-bloom-siyah-baglama-bolero",
  ],
  "eternal-bloom-kahverengi-tayt": [
    "eternal-bloom-kahverengi-bra",
    "eternal-bloom-kahverengi-atlet",
    "eternal-bloom-kahverengi-buzgulu-bra",
    "eternal-bloom-kahverengi-sort",
    "eternal-bloom-kahverengi-baglama-bolero",
  ],
  "eternal-bloom-gul-kurusu-tayt": [
    "eternal-bloom-gul-kurusu-bra",
    "eternal-bloom-gul-kurusu-atlet",
    "eternal-bloom-gul-kurusu-buzgulu-bra",
    "eternal-bloom-gul-kurusu-sort",
    "eternal-bloom-gul-kurusu-baglama-bolero",
  ],
  "eternal-bloom-yesil-tayt": [
    "eternal-bloom-yesil-bra",
    "eternal-bloom-yesil-atlet",
    "eternal-bloom-yesil-buzgulu-bra",
    "eternal-bloom-yesil-sort",
    "eternal-bloom-yesil-sirt-dekolte-tulum",
  ],
  "eternal-bloom-siyah-sort": [
    "eternal-bloom-siyah-tayt",
    "eternal-bloom-siyah-bra",
    "eternal-bloom-siyah-atlet",
    "eternal-bloom-siyah-buzgulu-bra",
    "eternal-bloom-siyah-baglama-bolero",
  ],
  "eternal-bloom-kahverengi-sort": [
    "eternal-bloom-kahverengi-tayt",
    "eternal-bloom-kahverengi-bra",
    "eternal-bloom-kahverengi-atlet",
    "eternal-bloom-kahverengi-buzgulu-bra",
    "eternal-bloom-kahverengi-baglama-bolero",
  ],
  "eternal-bloom-gul-kurusu-sort": [
    "eternal-bloom-gul-kurusu-tayt",
    "eternal-bloom-gul-kurusu-bra",
    "eternal-bloom-gul-kurusu-atlet",
    "eternal-bloom-gul-kurusu-buzgulu-bra",
    "eternal-bloom-gul-kurusu-baglama-bolero",
  ],
  "eternal-bloom-yesil-sort": [
    "eternal-bloom-yesil-tayt",
    "eternal-bloom-yesil-bra",
    "eternal-bloom-yesil-atlet",
    "eternal-bloom-yesil-buzgulu-bra",
    "eternal-bloom-yesil-sirt-dekolte-tulum",
  ],
  "sunbeam-mor-straplez-bra": [
    "sunbeam-mor-tayt",
    "sunbeam-mor-sort",
    "sunbeam-mor-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-shaker",
  ],
  "sunbeam-acik-kahve-straplez-bra": [
    "sunbeam-acik-kahve-tayt",
    "sunbeam-acik-kahve-sort",
    "sunbeam-acik-kahve-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-corap",
  ],
  "sunbeam-mor-bra": [
    "sunbeam-mor-tayt",
    "sunbeam-mor-sort",
    "sunbeam-mor-straplez-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-shaker",
  ],
  "sunbeam-acik-kahve-bra": [
    "sunbeam-acik-kahve-tayt",
    "sunbeam-acik-kahve-sort",
    "sunbeam-acik-kahve-straplez-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-corap",
  ],
  "sunbeam-mor-sort": [
    "sunbeam-mor-tayt",
    "sunbeam-mor-bra",
    "sunbeam-mor-straplez-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-shaker",
  ],
  "sunbeam-acik-kahve-sort": [
    "sunbeam-acik-kahve-tayt",
    "sunbeam-acik-kahve-bra",
    "sunbeam-acik-kahve-straplez-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-corap",
  ],
  "sunbeam-mor-tayt": [
    "sunbeam-mor-bra",
    "sunbeam-mor-sort",
    "sunbeam-mor-straplez-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-shaker",
  ],
  "sunbeam-acik-kahve-tayt": [
    "sunbeam-acik-kahve-bra",
    "sunbeam-acik-kahve-sort",
    "sunbeam-acik-kahve-straplez-bra",
    "dossha-sapka-made-of-sunshine",
    "dossha-corap",
  ],
  "eternal-bloom-ekru-baglama-bolero": [
    "eternal-bloom-beyaz-bra",
    "eternal-bloom-beyaz-atlet",
    "eternal-bloom-beyaz-buzgulu-bra",
    "loungewear-beyaz-hoodie",
    "dossha-shaker",
  ],
  "eternal-bloom-gul-kurusu-baglama-bolero": [
    "eternal-bloom-gul-kurusu-tayt",
    "eternal-bloom-gul-kurusu-bra",
    "eternal-bloom-gul-kurusu-atlet",
    "eternal-bloom-gul-kurusu-sort",
    "dossha-corap",
  ],
  "eternal-bloom-kahverengi-baglama-bolero": [
    "eternal-bloom-kahverengi-tayt",
    "eternal-bloom-kahverengi-bra",
    "eternal-bloom-kahverengi-atlet",
    "eternal-bloom-kahverengi-sort",
    "dossha-shaker",
  ],
  "eternal-bloom-siyah-baglama-bolero": [
    "eternal-bloom-siyah-tayt",
    "eternal-bloom-siyah-bra",
    "eternal-bloom-siyah-atlet",
    "eternal-bloom-siyah-sort",
    "dossha-corap",
  ],
  "court-kiss-beyaz-elbise": [
    "dossha-sapka-meet-me-at-the-court",
    "court-kiss-bej-bra",
    "court-kiss-bej-etek",
    "court-kiss-bej-omuz-bolero",
    "dossha-shaker",
  ],
  "court-kiss-bej-etek": [
    "court-kiss-bej-bra",
    "court-kiss-bej-omuz-bolero",
    "court-kiss-beyaz-elbise",
    "dossha-sapka-meet-me-at-the-court",
    "dossha-shaker",
  ],
  "court-kiss-bej-bra": [
    "court-kiss-bej-etek",
    "court-kiss-bej-omuz-bolero",
    "court-kiss-beyaz-elbise",
    "dossha-sapka-meet-me-at-the-court",
    "dossha-corap",
  ],
  "court-kiss-bej-omuz-bolero": [
    "court-kiss-bej-bra",
    "court-kiss-bej-etek",
    "court-kiss-beyaz-elbise",
    "dossha-sapka-meet-me-at-the-court",
    "dossha-shaker",
  ],
  "self-love-ekru-tisort": [
    "loungewear-ekru-jogger",
    "loungewear-ekru-sweatshirt",
    "loungewear-dossha-ekru-sort",
    "sweatshirt-ekru",
    "dossha-corap",
  ],
  "cherry-ekru-tisort": [
    "loungewear-ekru-jogger",
    "loungewear-ekru-sweatshirt",
    "loungewear-dossha-ekru-sort",
    "sweatshirt-ekru",
    "dossha-shaker",
  ],
  "loungewear-dossha-kahverengi-crop-tisort": [
    "loungewear-dossha-kahverengi-sort",
    "loungewear-espresso-hoodie",
    "loungewear-espresso-wide-leg-esofman",
    "browny-sac-bandi",
    "dossha-corap",
  ],
  "loungewear-dossha-yesil-crop-tisort": [
    "loungewear-dossha-yesil-sort",
    "eternal-bloom-yesil-tayt",
    "eternal-bloom-yesil-bra",
    "loungewear-fiyonklu-beyaz-yesil-corap",
    "dossha-shaker",
  ],
  "loungewear-dossha-ekru-crop-tisort": [
    "loungewear-dossha-ekru-sort",
    "loungewear-ekru-jogger",
    "loungewear-ekru-sweatshirt",
    "self-love-ekru-tisort",
    "dossha-corap",
  ],
  "loungewear-dossha-kahverengi-sort": [
    "loungewear-dossha-kahverengi-crop-tisort",
    "loungewear-espresso-hoodie",
    "loungewear-espresso-wide-leg-esofman",
    "browny-sac-bandi",
    "dossha-shaker",
  ],
  "loungewear-dossha-yesil-sort": [
    "loungewear-dossha-yesil-crop-tisort",
    "eternal-bloom-yesil-sort",
    "eternal-bloom-yesil-atlet",
    "loungewear-fiyonklu-beyaz-yesil-corap",
    "dossha-corap",
  ],
  "loungewear-dossha-ekru-sort": [
    "loungewear-dossha-ekru-crop-tisort",
    "loungewear-ekru-jogger",
    "loungewear-ekru-sweatshirt",
    "cherry-ekru-tisort",
    "dossha-shaker",
  ],
  "loungewear-it-girl-yazili-beyaz-kahverengi-corap": [
    "loungewear-dossha-kahverengi-sort",
    "loungewear-espresso-hoodie",
    "browny-sac-bandi",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "loungewear-it-girl-yazili-beyaz-pembe-corap": [
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-bra",
    "aura-ballerina-pink-tayt",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "loungewear-it-girl-yazili-beyaz-yesil-corap": [
    "loungewear-dossha-yesil-sort",
    "eternal-bloom-yesil-tayt",
    "eternal-bloom-yesil-bra",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "loungewear-fiyonklu-beyaz-pembe-corap": [
    "loungewear-ballerina-pink-baglama-bolero",
    "aura-ballerina-pink-sort",
    "glow-n-flow-pembe-bra",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "loungewear-fiyonklu-beyaz-yesil-corap": [
    "loungewear-dossha-yesil-sort",
    "eternal-bloom-yesil-sort",
    "eternal-bloom-yesil-atlet",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "loungewear-fiyonklu-beyaz-turuncu-corap": [
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-tayt",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "dossha-sapka-meet-me-at-the-court": [
    "court-kiss-beyaz-elbise",
    "court-kiss-bej-bra",
    "court-kiss-bej-etek",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "dossha-sapka-made-of-sunshine": [
    "sunbeam-mor-tayt",
    "sunbeam-mor-bra",
    "sunbeam-acik-kahve-sort",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "glow-n-flow-pembe-bolero": [
    "glow-n-flow-pembe-tayt",
    "glow-n-flow-pembe-bra",
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-crop",
    "glow-n-flow-pembe-capraz-aski-bra",
  ],
  "glow-n-flow-turuncu-bolero": [
    "glow-n-flow-turuncu-tayt",
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-crop",
    "glow-n-flow-turuncu-capraz-aski-bra",
  ],
  "glow-n-flow-beyaz-bolero": [
    "glow-n-flow-beyaz-bra",
    "glow-n-flow-beyaz-capraz-aski-bra",
    "glow-n-flow-beyaz-straplez-bra",
    "it-girl-beyaz-tisort",
    "dossha-shaker",
  ],
  "glow-n-flow-pembe-bra": [
    "glow-n-flow-pembe-tayt",
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-bolero",
    "glow-n-flow-pembe-crop",
    "glow-n-flow-pembe-capraz-aski-bra",
  ],
  "glow-n-flow-turuncu-bra": [
    "glow-n-flow-turuncu-tayt",
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-bolero",
    "glow-n-flow-turuncu-crop",
    "glow-n-flow-turuncu-capraz-aski-bra",
  ],
  "glow-n-flow-beyaz-bra": [
    "glow-n-flow-beyaz-bolero",
    "glow-n-flow-beyaz-capraz-aski-bra",
    "glow-n-flow-beyaz-straplez-bra",
    "it-girl-beyaz-burgu-bra",
    "dossha-corap",
  ],
  "glow-n-flow-pembe-capraz-aski-bra": [
    "glow-n-flow-pembe-tayt",
    "glow-n-flow-pembe-bra",
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-bolero",
    "glow-n-flow-pembe-crop",
  ],
  "glow-n-flow-turuncu-capraz-aski-bra": [
    "glow-n-flow-turuncu-tayt",
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-bolero",
    "glow-n-flow-turuncu-crop",
  ],
  "glow-n-flow-beyaz-capraz-aski-bra": [
    "glow-n-flow-beyaz-bra",
    "glow-n-flow-beyaz-bolero",
    "glow-n-flow-beyaz-straplez-bra",
    "it-girl-beyaz-crop",
    "dossha-shaker",
  ],
  "glow-n-flow-pembe-straplez-bra": [
    "glow-n-flow-pembe-tayt",
    "glow-n-flow-pembe-bra",
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-bolero",
    "glow-n-flow-pembe-crop",
  ],
  "glow-n-flow-turuncu-straplez-bra": [
    "glow-n-flow-turuncu-tayt",
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-bolero",
    "glow-n-flow-turuncu-crop",
  ],
  "glow-n-flow-beyaz-straplez-bra": [
    "glow-n-flow-beyaz-bra",
    "glow-n-flow-beyaz-bolero",
    "glow-n-flow-beyaz-capraz-aski-bra",
    "it-girl-beyaz-burgu-bra",
    "dossha-corap",
  ],
  "glow-n-flow-pembe-tayt": [
    "glow-n-flow-pembe-bra",
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-bolero",
    "glow-n-flow-pembe-crop",
    "glow-n-flow-pembe-capraz-aski-bra",
  ],
  "glow-n-flow-turuncu-tayt": [
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-bolero",
    "glow-n-flow-turuncu-crop",
    "glow-n-flow-turuncu-capraz-aski-bra",
  ],
  "glow-n-flow-pembe-sort": [
    "glow-n-flow-pembe-tayt",
    "glow-n-flow-pembe-bra",
    "glow-n-flow-pembe-bolero",
    "glow-n-flow-pembe-crop",
    "glow-n-flow-pembe-capraz-aski-bra",
  ],
  "glow-n-flow-turuncu-sort": [
    "glow-n-flow-turuncu-tayt",
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-bolero",
    "glow-n-flow-turuncu-crop",
    "glow-n-flow-turuncu-capraz-aski-bra",
  ],
  "glow-n-flow-pembe-biyeli-crop": [
    "glow-n-flow-pembe-tayt",
    "glow-n-flow-pembe-bra",
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-bolero",
    "glow-n-flow-pembe-crop",
  ],
  "glow-n-flow-turuncu-biyeli-crop": [
    "glow-n-flow-turuncu-tayt",
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-bolero",
    "glow-n-flow-turuncu-crop",
  ],
  "glow-n-flow-pembe-crop": [
    "glow-n-flow-pembe-tayt",
    "glow-n-flow-pembe-bra",
    "glow-n-flow-pembe-sort",
    "glow-n-flow-pembe-bolero",
    "glow-n-flow-pembe-capraz-aski-bra",
  ],
  "glow-n-flow-turuncu-crop": [
    "glow-n-flow-turuncu-tayt",
    "glow-n-flow-turuncu-bra",
    "glow-n-flow-turuncu-sort",
    "glow-n-flow-turuncu-bolero",
    "glow-n-flow-turuncu-capraz-aski-bra",
  ],
  "dossha-termos-600-ml": [
    "dossha-shaker",
    "dossha-corap",
    "dossha-sapka-ciao-amore",
    "dossha-sapka-hot-stuff",
    "dossha-kisa-corap",
  ],
  "glow-n-flow-butter-yellow-bolero": [
    "glow-n-flow-butter-yellow-tayt",
    "glow-n-flow-butter-yellow-bra",
    "glow-n-flow-butter-yellow-sort",
    "glow-n-flow-butter-yellow-crop",
    "glow-n-flow-butter-yellow-capraz-aski-bra",
  ],
  "glow-n-flow-butter-yellow-bra": [
    "glow-n-flow-butter-yellow-tayt",
    "glow-n-flow-butter-yellow-sort",
    "glow-n-flow-butter-yellow-bolero",
    "glow-n-flow-butter-yellow-crop",
    "glow-n-flow-butter-yellow-capraz-aski-bra",
  ],
  "glow-n-flow-butter-yellow-capraz-aski-bra": [
    "glow-n-flow-butter-yellow-tayt",
    "glow-n-flow-butter-yellow-bra",
    "glow-n-flow-butter-yellow-sort",
    "glow-n-flow-butter-yellow-bolero",
    "glow-n-flow-butter-yellow-crop",
  ],
  "glow-n-flow-butter-yellow-straplez-bra": [
    "glow-n-flow-butter-yellow-tayt",
    "glow-n-flow-butter-yellow-bra",
    "glow-n-flow-butter-yellow-sort",
    "glow-n-flow-butter-yellow-bolero",
    "glow-n-flow-butter-yellow-crop",
  ],
  "glow-n-flow-butter-yellow-tayt": [
    "glow-n-flow-butter-yellow-bra",
    "glow-n-flow-butter-yellow-sort",
    "glow-n-flow-butter-yellow-bolero",
    "glow-n-flow-butter-yellow-crop",
    "glow-n-flow-butter-yellow-capraz-aski-bra",
  ],
  "glow-n-flow-butter-yellow-sort": [
    "glow-n-flow-butter-yellow-tayt",
    "glow-n-flow-butter-yellow-bra",
    "glow-n-flow-butter-yellow-bolero",
    "glow-n-flow-butter-yellow-crop",
    "glow-n-flow-butter-yellow-capraz-aski-bra",
  ],
  "glow-n-flow-butter-yellow-biyeli-crop": [
    "glow-n-flow-butter-yellow-tayt",
    "glow-n-flow-butter-yellow-bra",
    "glow-n-flow-butter-yellow-sort",
    "glow-n-flow-butter-yellow-bolero",
    "glow-n-flow-butter-yellow-crop",
  ],
  "glow-n-flow-butter-yellow-crop": [
    "glow-n-flow-butter-yellow-tayt",
    "glow-n-flow-butter-yellow-bra",
    "glow-n-flow-butter-yellow-sort",
    "glow-n-flow-butter-yellow-bolero",
    "glow-n-flow-butter-yellow-capraz-aski-bra",
  ],
  "glow-n-flow-lila-bolero": [
    "glow-n-flow-lila-tayt",
    "glow-n-flow-lila-bra",
    "glow-n-flow-lila-sort",
    "glow-n-flow-lila-crop",
    "glow-n-flow-lila-capraz-aski-bra",
  ],
  "glow-n-flow-lila-bra": [
    "glow-n-flow-lila-tayt",
    "glow-n-flow-lila-sort",
    "glow-n-flow-lila-bolero",
    "glow-n-flow-lila-crop",
    "glow-n-flow-lila-capraz-aski-bra",
  ],
  "glow-n-flow-lila-capraz-aski-bra": [
    "glow-n-flow-lila-tayt",
    "glow-n-flow-lila-bra",
    "glow-n-flow-lila-sort",
    "glow-n-flow-lila-bolero",
    "glow-n-flow-lila-crop",
  ],
  "glow-n-flow-lila-straplez-bra": [
    "glow-n-flow-lila-tayt",
    "glow-n-flow-lila-bra",
    "glow-n-flow-lila-sort",
    "glow-n-flow-lila-bolero",
    "glow-n-flow-lila-crop",
  ],
  "glow-n-flow-lila-tayt": [
    "glow-n-flow-lila-bra",
    "glow-n-flow-lila-sort",
    "glow-n-flow-lila-bolero",
    "glow-n-flow-lila-crop",
    "glow-n-flow-lila-capraz-aski-bra",
  ],
  "glow-n-flow-lila-sort": [
    "glow-n-flow-lila-tayt",
    "glow-n-flow-lila-bra",
    "glow-n-flow-lila-bolero",
    "glow-n-flow-lila-crop",
    "glow-n-flow-lila-capraz-aski-bra",
  ],
  "glow-n-flow-lila-biyeli-crop": [
    "glow-n-flow-lila-tayt",
    "glow-n-flow-lila-bra",
    "glow-n-flow-lila-sort",
    "glow-n-flow-lila-bolero",
    "glow-n-flow-lila-crop",
  ],
  "glow-n-flow-lila-crop": [
    "glow-n-flow-lila-tayt",
    "glow-n-flow-lila-bra",
    "glow-n-flow-lila-sort",
    "glow-n-flow-lila-bolero",
    "glow-n-flow-lila-capraz-aski-bra",
  ],
  "glow-n-flow-saks-mavi-bolero": [
    "glow-n-flow-saks-mavi-tayt",
    "glow-n-flow-saks-mavi-bra",
    "glow-n-flow-saks-mavi-sort",
    "glow-n-flow-saks-mavi-crop",
    "glow-n-flow-saks-mavi-capraz-aski-bra",
  ],
  "glow-n-flow-saks-mavi-bra": [
    "glow-n-flow-saks-mavi-tayt",
    "glow-n-flow-saks-mavi-sort",
    "glow-n-flow-saks-mavi-bolero",
    "glow-n-flow-saks-mavi-crop",
    "glow-n-flow-saks-mavi-capraz-aski-bra",
  ],
  "glow-n-flow-saks-mavi-capraz-aski-bra": [
    "glow-n-flow-saks-mavi-tayt",
    "glow-n-flow-saks-mavi-bra",
    "glow-n-flow-saks-mavi-sort",
    "glow-n-flow-saks-mavi-bolero",
    "glow-n-flow-saks-mavi-crop",
  ],
  "glow-n-flow-saks-mavi-straplez-bra": [
    "glow-n-flow-saks-mavi-tayt",
    "glow-n-flow-saks-mavi-bra",
    "glow-n-flow-saks-mavi-sort",
    "glow-n-flow-saks-mavi-bolero",
    "glow-n-flow-saks-mavi-crop",
  ],
  "glow-n-flow-saks-mavi-tayt": [
    "glow-n-flow-saks-mavi-bra",
    "glow-n-flow-saks-mavi-sort",
    "glow-n-flow-saks-mavi-bolero",
    "glow-n-flow-saks-mavi-crop",
    "glow-n-flow-saks-mavi-capraz-aski-bra",
  ],
  "glow-n-flow-saks-mavi-sort": [
    "glow-n-flow-saks-mavi-tayt",
    "glow-n-flow-saks-mavi-bra",
    "glow-n-flow-saks-mavi-bolero",
    "glow-n-flow-saks-mavi-crop",
    "glow-n-flow-saks-mavi-capraz-aski-bra",
  ],
  "glow-n-flow-saks-mavi-biyeli-crop": [
    "glow-n-flow-saks-mavi-tayt",
    "glow-n-flow-saks-mavi-bra",
    "glow-n-flow-saks-mavi-sort",
    "glow-n-flow-saks-mavi-bolero",
    "glow-n-flow-saks-mavi-crop",
  ],
  "glow-n-flow-saks-mavi-crop": [
    "glow-n-flow-saks-mavi-tayt",
    "glow-n-flow-saks-mavi-bra",
    "glow-n-flow-saks-mavi-sort",
    "glow-n-flow-saks-mavi-bolero",
    "glow-n-flow-saks-mavi-capraz-aski-bra",
  ],
  "aura-siyah-bra": [
    "aura-siyah-tayt",
    "aura-siyah-ceket",
    "aura-siyah-atlet",
    "aura-siyah-sort",
    "aura-siyah-sac-bandi",
  ],
  "aura-siyah-atlet": [
    "aura-siyah-tayt",
    "aura-siyah-bra",
    "aura-siyah-ceket",
    "aura-siyah-sort",
    "aura-siyah-sac-bandi",
  ],
  "aura-siyah-ceket": [
    "aura-siyah-tayt",
    "aura-siyah-bra",
    "aura-siyah-atlet",
    "aura-siyah-sort",
    "aura-siyah-sac-bandi",
  ],
  "aura-siyah-tayt": [
    "aura-siyah-bra",
    "aura-siyah-ceket",
    "aura-siyah-atlet",
    "aura-siyah-sort",
    "aura-siyah-sac-bandi",
  ],
  "aura-siyah-sort": [
    "aura-siyah-tayt",
    "aura-siyah-bra",
    "aura-siyah-ceket",
    "aura-siyah-atlet",
    "aura-siyah-sac-bandi",
  ],
  "aura-siyah-pantolon": [
    "aura-siyah-bra",
    "aura-siyah-ceket",
    "aura-siyah-atlet",
    "aura-siyah-tayt",
    "aura-siyah-sac-bandi",
  ],
  "aura-siyah-tulum": [
    "aura-siyah-bra",
    "aura-siyah-ceket",
    "aura-siyah-atlet",
    "aura-siyah-sac-bandi",
    "dossha-corap",
  ],
  "aura-ballerina-pink-bra": [
    "aura-ballerina-pink-tayt",
    "aura-ballerina-pink-ceket",
    "aura-ballerina-pink-atlet",
    "aura-ballerina-pink-sort",
    "aura-ballerina-pink-sac-bandi",
  ],
  "aura-ballerina-pink-atlet": [
    "aura-ballerina-pink-tayt",
    "aura-ballerina-pink-bra",
    "aura-ballerina-pink-ceket",
    "aura-ballerina-pink-sort",
    "aura-ballerina-pink-sac-bandi",
  ],
  "aura-ballerina-pink-ceket": [
    "aura-ballerina-pink-tayt",
    "aura-ballerina-pink-bra",
    "aura-ballerina-pink-atlet",
    "aura-ballerina-pink-sort",
    "aura-ballerina-pink-sac-bandi",
  ],
  "aura-ballerina-pink-tayt": [
    "aura-ballerina-pink-bra",
    "aura-ballerina-pink-ceket",
    "aura-ballerina-pink-atlet",
    "aura-ballerina-pink-sort",
    "aura-ballerina-pink-sac-bandi",
  ],
  "aura-ballerina-pink-sort": [
    "aura-ballerina-pink-tayt",
    "aura-ballerina-pink-bra",
    "aura-ballerina-pink-ceket",
    "aura-ballerina-pink-atlet",
    "aura-ballerina-pink-sac-bandi",
  ],
  "aura-ballerina-pink-pantolon": [
    "aura-ballerina-pink-bra",
    "aura-ballerina-pink-ceket",
    "aura-ballerina-pink-atlet",
    "aura-ballerina-pink-tayt",
    "aura-ballerina-pink-sac-bandi",
  ],
  "aura-espresso-bra": [
    "aura-espresso-tayt",
    "aura-espresso-ceket",
    "aura-espresso-atlet",
    "aura-espresso-sort",
    "aura-espresso-sac-bandi",
  ],
  "aura-espresso-atlet": [
    "aura-espresso-tayt",
    "aura-espresso-bra",
    "aura-espresso-ceket",
    "aura-espresso-sort",
    "aura-espresso-sac-bandi",
  ],
  "aura-espresso-ceket": [
    "aura-espresso-tayt",
    "aura-espresso-bra",
    "aura-espresso-atlet",
    "aura-espresso-sort",
    "aura-espresso-sac-bandi",
  ],
  "aura-espresso-tayt": [
    "aura-espresso-bra",
    "aura-espresso-ceket",
    "aura-espresso-atlet",
    "aura-espresso-sort",
    "aura-espresso-sac-bandi",
  ],
  "aura-espresso-sort": [
    "aura-espresso-tayt",
    "aura-espresso-bra",
    "aura-espresso-ceket",
    "aura-espresso-atlet",
    "aura-espresso-sac-bandi",
  ],
  "aura-espresso-pantolon": [
    "aura-espresso-bra",
    "aura-espresso-ceket",
    "aura-espresso-atlet",
    "aura-espresso-tayt",
    "aura-espresso-sac-bandi",
  ],
  "aura-espresso-tulum": [
    "aura-espresso-bra",
    "aura-espresso-ceket",
    "aura-espresso-atlet",
    "aura-espresso-sac-bandi",
    "dossha-shaker",
  ],
  "loungewear-ekru-jogger": [
    "loungewear-ekru-sweatshirt",
    "self-love-ekru-tisort",
    "cherry-ekru-tisort",
    "loungewear-dossha-ekru-crop-tisort",
    "dossha-corap",
  ],
  "loungewear-ekru-sweatshirt": [
    "loungewear-ekru-jogger",
    "self-love-ekru-tisort",
    "cherry-ekru-tisort",
    "loungewear-dossha-ekru-sort",
    "dossha-shaker",
  ],
  "loungewear-gri-melanj-jogger": [
    "loungewear-gri-melanj-sweatshirt",
    "loungewear-gri-melanj-hoodie",
    "loungewear-gri-melanj-wide-leg-esofman",
    "sweatshirt-gri",
    "dossha-corap",
  ],
  "loungewear-gri-melanj-sweatshirt": [
    "loungewear-gri-melanj-jogger",
    "loungewear-gri-melanj-hoodie",
    "loungewear-gri-melanj-wide-leg-esofman",
    "sweatshirt-gri",
    "dossha-shaker",
  ],
  "loungewear-espresso-hoodie": [
    "loungewear-espresso-wide-leg-esofman",
    "aura-espresso-tayt",
    "aura-espresso-bra",
    "loungewear-it-girl-yazili-beyaz-kahverengi-corap",
    "dossha-corap",
  ],
  "loungewear-espresso-wide-leg-esofman": [
    "loungewear-espresso-hoodie",
    "aura-espresso-tayt",
    "aura-espresso-bra",
    "loungewear-it-girl-yazili-beyaz-kahverengi-corap",
    "dossha-shaker",
  ],
  "loungewear-gri-melanj-hoodie": [
    "loungewear-gri-melanj-wide-leg-esofman",
    "loungewear-gri-melanj-jogger",
    "loungewear-gri-melanj-sweatshirt",
    "sweatshirt-gri",
    "dossha-corap",
  ],
  "loungewear-gri-melanj-wide-leg-esofman": [
    "loungewear-gri-melanj-hoodie",
    "loungewear-gri-melanj-jogger",
    "loungewear-gri-melanj-sweatshirt",
    "sweatshirt-gri",
    "dossha-shaker",
  ],
  "aura-siyah-sac-bandi": [
    "aura-siyah-tayt",
    "aura-siyah-bra",
    "aura-siyah-ceket",
    "aura-siyah-atlet",
    "dossha-shaker",
  ],
  "aura-ballerina-pink-sac-bandi": [
    "aura-ballerina-pink-tayt",
    "aura-ballerina-pink-bra",
    "aura-ballerina-pink-ceket",
    "aura-ballerina-pink-atlet",
    "dossha-corap",
  ],
  "aura-espresso-sac-bandi": [
    "aura-espresso-tayt",
    "aura-espresso-bra",
    "aura-espresso-ceket",
    "aura-espresso-atlet",
    "dossha-shaker",
  ],
  "dossha-kisa-corap": [
    "dossha-shaker",
    "dossha-termos-600-ml",
    "dossha-corap",
    "timeless-sac-bandi",
    "aura-siyah-sac-bandi",
  ],
  "hedi\u0307ye-karti": [
    "dossha-shaker",
    "dossha-termos-600-ml",
    "dossha-sapka-hot-stuff",
    "dossha-corap",
    "timeless-sac-bandi",
  ],
  "loungewear-ballerina-pink-baglama-bolero": [
    "aura-ballerina-pink-tayt",
    "aura-ballerina-pink-bra",
    "aura-ballerina-pink-sort",
    "loungewear-fiyonklu-beyaz-pembe-corap",
    "dossha-corap",
  ],
  "aura-bordo-sac-bandi": [
    "aura-bordo-tayt",
    "aura-bordo-bra",
    "aura-bordo-ceket",
    "aura-bordo-atlet",
    "dossha-shaker",
  ],
  "aura-bordo-tulum": [
    "aura-bordo-bra",
    "aura-bordo-ceket",
    "aura-bordo-atlet",
    "aura-bordo-sac-bandi",
    "dossha-corap",
  ],
  "aura-bordo-pantolon": [
    "aura-bordo-bra",
    "aura-bordo-ceket",
    "aura-bordo-atlet",
    "aura-bordo-tayt",
    "aura-bordo-sac-bandi",
  ],
  "aura-bordo-sort": [
    "aura-bordo-tayt",
    "aura-bordo-bra",
    "aura-bordo-ceket",
    "aura-bordo-atlet",
    "aura-bordo-sac-bandi",
  ],
  "aura-bordo-tayt": [
    "aura-bordo-bra",
    "aura-bordo-ceket",
    "aura-bordo-atlet",
    "aura-bordo-sort",
    "aura-bordo-sac-bandi",
  ],
  "aura-bordo-ceket": [
    "aura-bordo-tayt",
    "aura-bordo-bra",
    "aura-bordo-atlet",
    "aura-bordo-sort",
    "aura-bordo-sac-bandi",
  ],
  "aura-bordo-atlet": [
    "aura-bordo-tayt",
    "aura-bordo-bra",
    "aura-bordo-ceket",
    "aura-bordo-sort",
    "aura-bordo-sac-bandi",
  ],
  "aura-bordo-bra": [
    "aura-bordo-tayt",
    "aura-bordo-ceket",
    "aura-bordo-atlet",
    "aura-bordo-sort",
    "aura-bordo-sac-bandi",
  ],
  "aura-lacivert-sac-bandi": [
    "aura-lacivert-tayt",
    "aura-lacivert-bra",
    "aura-lacivert-ceket",
    "aura-lacivert-atlet",
    "dossha-shaker",
  ],
  "aura-lacivert-tulum": [
    "aura-lacivert-bra",
    "aura-lacivert-ceket",
    "aura-lacivert-atlet",
    "aura-lacivert-sac-bandi",
    "dossha-corap",
  ],
  "aura-lacivert-pantolon": [
    "aura-lacivert-bra",
    "aura-lacivert-ceket",
    "aura-lacivert-atlet",
    "aura-lacivert-tayt",
    "aura-lacivert-sac-bandi",
  ],
  "aura-lacivert-sort": [
    "aura-lacivert-tayt",
    "aura-lacivert-bra",
    "aura-lacivert-ceket",
    "aura-lacivert-atlet",
    "aura-lacivert-sac-bandi",
  ],
  "aura-lacivert-tayt": [
    "aura-lacivert-bra",
    "aura-lacivert-ceket",
    "aura-lacivert-atlet",
    "aura-lacivert-sort",
    "aura-lacivert-sac-bandi",
  ],
  "aura-lacivert-ceket": [
    "aura-lacivert-tayt",
    "aura-lacivert-bra",
    "aura-lacivert-atlet",
    "aura-lacivert-sort",
    "aura-lacivert-sac-bandi",
  ],
  "aura-lacivert-atlet": [
    "aura-lacivert-tayt",
    "aura-lacivert-bra",
    "aura-lacivert-ceket",
    "aura-lacivert-sort",
    "aura-lacivert-sac-bandi",
  ],
  "aura-lacivert-bra": [
    "aura-lacivert-tayt",
    "aura-lacivert-ceket",
    "aura-lacivert-atlet",
    "aura-lacivert-sort",
    "aura-lacivert-sac-bandi",
  ],
  "aura-vanilya-sac-bandi": [
    "aura-vanilya-bra",
    "aura-vanilya-atlet",
    "aura-vanilya-ceket",
    "aura-vanilya-pantolon",
    "dossha-shaker",
  ],
  "aura-vanilya-pantolon": [
    "aura-vanilya-bra",
    "aura-vanilya-ceket",
    "aura-vanilya-atlet",
    "aura-vanilya-sort",
    "aura-vanilya-sac-bandi",
  ],
  "aura-vanilya-sort": [
    "aura-vanilya-bra",
    "aura-vanilya-ceket",
    "aura-vanilya-atlet",
    "aura-vanilya-pantolon",
    "aura-vanilya-sac-bandi",
  ],
  "aura-vanilya-ceket": [
    "aura-vanilya-bra",
    "aura-vanilya-atlet",
    "aura-vanilya-sort",
    "aura-vanilya-pantolon",
    "aura-vanilya-sac-bandi",
  ],
  "aura-vanilya-atlet": [
    "aura-vanilya-bra",
    "aura-vanilya-ceket",
    "aura-vanilya-sort",
    "aura-vanilya-pantolon",
    "aura-vanilya-sac-bandi",
  ],
  "aura-vanilya-bra": [
    "aura-vanilya-atlet",
    "aura-vanilya-ceket",
    "aura-vanilya-sort",
    "aura-vanilya-pantolon",
    "aura-vanilya-sac-bandi",
  ],
  "loungewear-beyaz-wide-leg-esofman": [
    "loungewear-beyaz-hoodie",
    "it-girl-beyaz-tisort",
    "it-girl-beyaz-burgu-bra",
    "dossha-corap",
    "dossha-termos-600-ml",
  ],
  "loungewear-beyaz-hoodie": [
    "loungewear-beyaz-wide-leg-esofman",
    "it-girl-beyaz-tisort",
    "it-girl-beyaz-crop",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "loungewear-siyah-wide-leg-esofman": [
    "loungewear-siyah-hoodie",
    "aura-siyah-tayt",
    "aura-siyah-bra",
    "dossha-corap",
    "dossha-termos-600-ml",
  ],
  "loungewear-siyah-hoodie": [
    "loungewear-siyah-wide-leg-esofman",
    "aura-siyah-ceket",
    "aura-siyah-atlet",
    "dossha-shaker",
    "dossha-termos-600-ml",
  ],
  "atmosfer-siyah-atlet": [
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-sporcu-bra",
    "atmosfer-siyah-sort",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-siyah-buzgulu-atlet": [
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-buzgulu-bra",
    "atmosfer-siyah-sort",
    "atmosfer-siyah-kapri-tayt",
    "atmosfer-siyah-atlet",
  ],
  "atmosfer-siyah-buzgulu-bra": [
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-buzgulu-atlet",
    "atmosfer-siyah-kapri-tayt",
    "atmosfer-siyah-sort",
    "atmosfer-siyah-sporcu-bra",
  ],
  "atmosfer-siyah-kapri-tayt": [
    "atmosfer-siyah-buzgu-bra",
    "atmosfer-siyah-buzgu-atlet",
    "atmosfer-siyah-tayt",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-siyah-sporcu-bra": [
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-sort",
    "atmosfer-siyah-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-siyah-sort": [
    "atmosfer-siyah-sporcu-bra",
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-siyah-tayt": [
    "atmosfer-siyah-sporcu-bra",
    "atmosfer-siyah-sort",
    "atmosfer-siyah-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki\u0307-atlet": [
    "atmosfer-haki-tayt",
    "atmosfer-haki-sporcu-bra",
    "atmosfer-haki-buzgulu-bra",
    "atmosfer-haki-sort",
    "atmosfer-haki-sac-bandi",
  ],
  "atmosfer-haki-buzgulu-bra": [
    "atmosfer-haki-tayt",
    "atmosfer-haki-sekilendirici-tayt",
    "atmosfer-haki\u0307-atlet",
    "atmosfer-haki-sort",
    "atmosfer-haki-sac-bandi",
  ],
  "atmosfer-haki-sporcu-bra": [
    "atmosfer-haki-tayt",
    "atmosfer-haki-sort",
    "atmosfer-haki̇-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki-sekilendirici-tayt": [
    "atmosfer-haki-buzgu-bra",
    "atmosfer-haki-tayt",
    "atmosfer-haki-sac-bandi",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki-sort": [
    "atmosfer-haki-sporcu-bra",
    "atmosfer-haki-tayt",
    "atmosfer-haki̇-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki-tayt": [
    "atmosfer-haki-sporcu-bra",
    "atmosfer-haki-sort",
    "atmosfer-haki̇-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki-sac-bandi": [
    "atmosfer-haki-tayt",
    "atmosfer-haki-sporcu-bra",
    "atmosfer-haki̇-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-espresso-atlet": [
    "atmosfer-espresso-kapri-tayt",
    "espresso-yoga-pantolonu",
    "espresso-basic-tisort",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-espresso-buzgulu-atlet": [
    "atmosfer-espresso-kapri-tayt",
    "atmosfer-espresso-yoga-pantolon",
    "atmosfer-espresso-atlet",
    "atmosfer-espresso-basic-tisort",
    "aura-espresso-tayt",
  ],
  "atmosfer-espresso-kapri-tayt": [
    "atmosfer-espresso-buzgu-atlet",
    "atmosfer-espresso-atlet",
    "espresso-basic-tisort",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-espresso-basic-tisort": [
    "atmosfer-espresso-yoga-pantolon",
    "atmosfer-espresso-kapri-tayt",
    "atmosfer-espresso-atlet",
    "atmosfer-espresso-buzgulu-atlet",
    "aura-espresso-pantolon",
  ],
  "atmosfer-espresso-yoga-pantolon": [
    "atmosfer-espresso-basic-tisort",
    "atmosfer-espresso-atlet",
    "atmosfer-espresso-kapri-tayt",
    "atmosfer-espresso-buzgulu-atlet",
    "aura-espresso-bra",
  ],
  "atmosfer-acik-haki-buzgulu-atlet": [
    "atmosfer-acik-haki-kapri-tayt",
    "atmosfer-haki-tayt",
    "atmosfer-haki-buzgulu-bra",
    "atmosfer-haki-sort",
    "atmosfer-haki-sac-bandi",
  ],
  "atmosfer-acik-haki-kapri-tayt": [
    "atmosfer-acik-haki-buzgu-atlet",
    "atmosfer-haki-tayt",
    "atmosfer-haki-sporcu-bra",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-buz-mavisi-atlet": [
    "atmosfer-buz-mavisi-tayt",
    "atmosfer-buz-mavisi-sporcu-bra",
    "atmosfer-buz-mavisi-sort",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-buz-mavisi-buzgulu-bra": [
    "atmosfer-buz-mavisi-tayt",
    "atmosfer-buz-mavisi-sekillendirici-tayt",
    "atmosfer-buz-mavisi-atlet",
    "atmosfer-buz-mavisi-sort",
    "atmosfer-buz-mavisi-sac-bandi",
  ],
  "atmosfer-buz-mavisi-sporcu-bra": [
    "atmosfer-buz-mavisi-tayt",
    "atmosfer-buz-mavisi-sort",
    "atmosfer-buz-mavisi-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-buz-mavisi-sekillendirici-tayt": [
    "atmosfer-buz-mavisi-buzgu-bra",
    "atmosfer-buz-mavisi-tayt",
    "atmosfer-buz-mavisi-sac-bandi",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-buz-mavisi-sort": [
    "atmosfer-buz-mavisi-sporcu-bra",
    "atmosfer-buz-mavisi-tayt",
    "atmosfer-buz-mavisi-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-buz-mavisi-tayt": [
    "atmosfer-buz-mavisi-sporcu-bra",
    "atmosfer-buz-mavisi-sort",
    "atmosfer-buz-mavisi-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-buz-mavisi-sac-bandi": [
    "atmosfer-buz-mavisi-tayt",
    "atmosfer-buz-mavisi-sporcu-bra",
    "atmosfer-buz-mavisi-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-beyaz-atlet": [
    "atmosfer-beyaz-sporcu-bra",
    "atmosfer-beyaz-buzgu-bra",
    "atmosfer-beyaz-buzgu-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-beyaz-buzgulu-atlet": [
    "atmosfer-beyaz-buzgulu-bra",
    "atmosfer-beyaz-sporcu-bra",
    "atmosfer-beyaz-atlet",
    "it-girl-beyaz-tisort",
    "dossha-shaker",
  ],
  "atmosfer-beyaz-buzgulu-bra": [
    "atmosfer-beyaz-buzgulu-atlet",
    "atmosfer-beyaz-sporcu-bra",
    "atmosfer-beyaz-atlet",
    "it-girl-beyaz-burgu-bra",
    "dossha-corap",
  ],
  "atmosfer-beyaz-sporcu-bra": [
    "atmosfer-beyaz-atlet",
    "atmosfer-beyaz-buzgu-bra",
    "atmosfer-beyaz-buzgu-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki-parasut-crop-ceket": [
    "atmosfer-haki-parasut-pantolon",
    "atmosfer-haki-parasut-sort",
    "atmosfer-haki-parasut-yarim-fermuarli-ceket",
    "atmosfer-haki\u0307-atlet",
    "atmosfer-haki-tayt",
  ],
  "atmosfer-haki-parasut-pantolon": [
    "atmosfer-haki-parasut-crop-ceket",
    "atmosfer-haki-parasut-yarim-fermuarli-ceket",
    "atmosfer-haki-parasut-sort",
    "atmosfer-haki\u0307-atlet",
    "atmosfer-haki-buzgulu-bra",
  ],
  "atmosfer-haki-parasut-sort": [
    "atmosfer-haki-parasut-crop-ceket",
    "atmosfer-haki-parasut-yarim-fermuarli-ceket",
    "atmosfer-haki-parasut-pantolon",
    "atmosfer-haki-sporcu-bra",
    "atmosfer-haki-buzgulu-bra",
  ],
  "atmosfer-haki-parasut-yarim-fermuarli-ceket": [
    "atmosfer-haki-parasut-pantolon",
    "atmosfer-haki-parasut-sort",
    "atmosfer-haki-parasut-crop-ceket",
    "atmosfer-haki\u0307-atlet",
    "atmosfer-haki-tayt",
  ],
  "atmosfer-siyah-parasut-crop-ceket": [
    "atmosfer-siyah-parasut-pantolon",
    "atmosfer-siyah-parasut-sort",
    "atmosfer-siyah-parasut-yarim-fermuarli-ceket",
    "atmosfer-siyah-atlet",
    "atmosfer-siyah-tayt",
  ],
  "atmosfer-siyah-parasut-pantolon": [
    "atmosfer-siyah-parasut-crop-ceket",
    "atmosfer-siyah-parasut-yarim-fermuarli-ceket",
    "atmosfer-siyah-parasut-sort",
    "atmosfer-siyah-atlet",
    "atmosfer-siyah-buzgulu-bra",
  ],
  "atmosfer-siyah-parasut-sort": [
    "atmosfer-siyah-parasut-crop-ceket",
    "atmosfer-siyah-parasut-yarim-fermuarli-ceket",
    "atmosfer-siyah-parasut-pantolon",
    "atmosfer-siyah-sporcu-bra",
    "atmosfer-siyah-buzgulu-bra",
  ],
  "atmosfer-siyah-parasut-yarim-fermuarli-ceket": [
    "atmosfer-siyah-parasut-pantolon",
    "atmosfer-siyah-parasut-sort",
    "atmosfer-siyah-parasut-crop-ceket",
    "atmosfer-siyah-atlet",
    "atmosfer-siyah-tayt",
  ],
  "atmosfer-siyah-basic-tisort": [
    "atmosfer-siyah-yoga-pantolon",
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-kapri-tayt",
    "atmosfer-siyah-sporcu-bra",
    "aura-siyah-pantolon",
  ],
  "atmosfer-siyah-yoga-pantolon": [
    "atmosfer-siyah-basic-tisort",
    "atmosfer-siyah-sporcu-bra",
    "atmosfer-siyah-buzgulu-bra",
    "atmosfer-siyah-tayt",
    "aura-siyah-bra",
  ],
  "dssh-nakisli-bilek-boy-corap": [
    "dssh-nakisli-orta-boy-corap",
    "atmosfer-siyah-tayt",
    "atmosfer-haki-tayt",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-siyah-buzgu-atlet": [
    "atmosfer-siyah-kapri-tayt",
    "atmosfer-siyah-buzgu-bra",
    "atmosfer-siyah-tayt",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-siyah-buzgu-bra": [
    "atmosfer-siyah-kapri-tayt",
    "atmosfer-siyah-buzgu-atlet",
    "atmosfer-siyah-tayt",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki̇-atlet": [
    "atmosfer-haki-tayt",
    "atmosfer-haki-sporcu-bra",
    "atmosfer-haki-sort",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-haki-buzgu-bra": [
    "atmosfer-haki-sekilendirici-tayt",
    "atmosfer-haki-tayt",
    "atmosfer-haki-sac-bandi",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-espresso-buzgu-atlet": [
    "atmosfer-espresso-kapri-tayt",
    "espresso-yoga-pantolonu",
    "espresso-basic-tisort",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-acik-haki-buzgu-atlet": [
    "atmosfer-acik-haki-kapri-tayt",
    "atmosfer-haki-tayt",
    "atmosfer-haki-sporcu-bra",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-buz-mavisi-buzgu-bra": [
    "atmosfer-buz-mavisi-sekillendirici-tayt",
    "atmosfer-buz-mavisi-tayt",
    "atmosfer-buz-mavisi-sac-bandi",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-beyaz-buzgu-atlet": [
    "atmosfer-beyaz-buzgu-bra",
    "atmosfer-beyaz-sporcu-bra",
    "atmosfer-beyaz-atlet",
    "vanilya-kanvas-canta",
  ],
  "atmosfer-beyaz-buzgu-bra": [
    "atmosfer-beyaz-buzgu-atlet",
    "atmosfer-beyaz-sporcu-bra",
    "atmosfer-beyaz-atlet",
    "vanilya-kanvas-canta",
  ],
  "haki-parasut-crop-ceket": [
    "haki-parasut-pantolon",
    "haki-parasut-yarim-fermuarli-ceket",
    "haki-parasut-sort",
    "vanilya-kanvas-canta",
  ],
  "haki-parasut-pantolon": [
    "haki-parasut-crop-ceket",
    "atmosfer-haki-buzgu-bra",
    "haki-parasut-sort",
    "vanilya-kanvas-canta",
  ],
  "haki-parasut-sort": [
    "haki-parasut-yarim-fermuarli-ceket",
    "atmosfer-haki-buzgu-bra",
    "haki-parasut-crop-ceket",
    "vanilya-kanvas-canta",
  ],
  "haki-parasut-yarim-fermuarli-ceket": [
    "haki-parasut-sort",
    "haki-parasut-pantolon",
    "haki-parasut-crop-ceket",
    "vanilya-kanvas-canta",
  ],
  "siyah-parasut-crop-ceket": [
    "siyah-parasut-pantolon",
    "siyah-parasut-yarim-fermuarli-ceket",
    "siyah-parasut-sort",
    "vanilya-kanvas-canta",
  ],
  "siyah-parasut-pantolon": [
    "siyah-parasut-crop-ceket",
    "siyah-parasut-yarim-fermuarli-ceket",
    "siyah-parasut-sort",
    "vanilya-kanvas-canta",
  ],
  "siyah-parasut-sort": [
    "siyah-parasut-yarim-fermuarli-ceket",
    "siyah-parasut-pantolon",
    "siyah-parasut-crop-ceket",
    "vanilya-kanvas-canta",
  ],
  "siyah-parasut-yarim-fermuarli-ceket": [
    "siyah-parasut-sort",
    "siyah-parasut-pantolon",
    "siyah-parasut-crop-ceket",
    "vanilya-kanvas-canta",
  ],
  "espresso-basic-tisort": [
    "espresso-yoga-pantolonu",
    "atmosfer-espresso-kapri-tayt",
    "atmosfer-espresso-atlet",
    "vanilya-kanvas-canta",
  ],
  "espresso-yoga-pantolonu": [
    "espresso-basic-tisort",
    "atmosfer-espresso-kapri-tayt",
    "atmosfer-espresso-atlet",
    "vanilya-kanvas-canta",
  ],
  "siyah-basic-tisort": [
    "siyah-yoga-pantolonu",
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-sort",
    "vanilya-kanvas-canta",
  ],
  "siyah-yoga-pantolonu": [
    "siyah-basic-tisort",
    "atmosfer-siyah-tayt",
    "atmosfer-siyah-sort",
    "vanilya-kanvas-canta",
  ],
  "dssh-nakisli-orta-boy-corap": [
    "dssh-nakisli-bilek-boy-corap",
    "atmosfer-siyah-tayt",
    "atmosfer-haki-tayt",
    "vanilya-kanvas-canta",
  ],
  "vanilya-kanvas-canta": [
    "haki-parasut-yarim-fermuarli-ceket",
    "atmosfer-haki-tayt",
    "siyah-basic-tisort",
    "vanilya-kanvas-canta",
  ],
};

const DOSSHA_PRODUCT_CACHE = {};

function dosshaFormatMoney(cents) {
  const format = window.theme?.settings?.money_format || "\u20BA{{amount}}";
  const amount = cents / 100;
  const formatted = new Intl.NumberFormat(Shopify.locale || "tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
  return format.replace(/\{\{.*?\}\}/, formatted);
}

function dosshaImageResize(src, size) {
  if (!src) return "";
  return src.replace(/(_\d+x\d+)?(\.(jpg|jpeg|png|gif|webp))/, `_${size}x$2`);
}

if (!customElements.get("dossha-cart-upsell")) {
  class DosshaCartUpsell extends HTMLElement {
    constructor() {
      super();
      this._swiperInstance = null;
      this._abortController = null;
    }

    connectedCallback() {
      this._abortController = new AbortController();
      this.init();
    }

    disconnectedCallback() {
      if (this._abortController) this._abortController.abort();
      if (this._swiperInstance) {
        this._swiperInstance.destroy(true, true);
        this._swiperInstance = null;
      }
    }

    async init() {
      const area = this.dataset.area || "cart-drawer";
      this.classList.add("is-hidden");
      this.innerHTML = "";

      try {
        const cart = await this.fetchCart();
        if (!cart || !cart.items || cart.items.length === 0) return;

        const recHandles = this.computeRecommendations(cart);
        if (recHandles.length === 0) return;

        const products = await this.fetchProducts(recHandles);
        if (products.length === 0) return;

        this.classList.remove("is-hidden");
        this.renderSlider(products, area);
        this.initSwiper();
        this.bindAddButtons();
      } catch (e) {
        if (e.name !== "AbortError") {
          console.error("[DOSSHA Upsell]", e);
          this.classList.add("is-hidden");
        }
      }
    }

    async fetchCart() {
      const resp = await fetch("/cart.js", {
        signal: this._abortController.signal,
      });
      return resp.json();
    }

    computeRecommendations(cart) {
      const cartHandles = new Set(cart.items.map((item) => item.handle));
      const scores = {};
      const PINNED_HANDLE = "vanilya-kanvas-canta";

      cart.items.forEach((item) => {
        const recs = DOSSHA_REC_MAP[item.handle];
        if (!recs) return;
        recs.forEach((rec, idx) => {
          if (cartHandles.has(rec)) return;
          scores[rec] = (scores[rec] || 0) + (5 - idx);
        });
      });

      const ranked = Object.entries(scores)
        .sort((a, b) => b[1] - a[1])
        .map((entry) => entry[0])
        .filter((handle) => handle !== PINNED_HANDLE);

      const result = [];
      if (!cartHandles.has(PINNED_HANDLE)) {
        result.push(PINNED_HANDLE);
      }
      result.push(...ranked);

      return result.slice(0, 10);
    }

    async fetchProducts(handles) {
      const results = await Promise.all(
        handles.map(async (handle) => {
          if (DOSSHA_PRODUCT_CACHE[handle] === null) {
            console.warn("[DOSSHA Upsell] cached miss:", handle);
            return null;
          }
          if (DOSSHA_PRODUCT_CACHE[handle]) return DOSSHA_PRODUCT_CACHE[handle];
          try {
            const resp = await fetch(`/products/${handle}.js`, {
              signal: this._abortController.signal,
            });
            if (!resp.ok) {
              console.warn(
                "[DOSSHA Upsell] fetch failed:",
                handle,
                resp.status,
              );
              DOSSHA_PRODUCT_CACHE[handle] = null;
              return null;
            }
            const product = await resp.json();
            DOSSHA_PRODUCT_CACHE[handle] = product;
            return product;
          } catch (e) {
            if (e.name !== "AbortError") {
              console.warn("[DOSSHA Upsell] fetch error:", handle, e.message);
              DOSSHA_PRODUCT_CACHE[handle] = null;
              return null;
            }
            throw e;
          }
        }),
      );
      return results.filter(Boolean);
    }

    renderSlider(products, area) {
      const slidesHTML = products
        .map((product) => this.renderCard(product))
        .join("");

      this.innerHTML = `
        <div class="dossha-upsell">
          <div class="dossha-upsell__header">
            <h5 class="dossha-upsell__title">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
              Setini Tamamla
            </h5>
          </div>
          <div class="dossha-upsell__slider">
            <div class="swiper dossha-upsell__swiper">
              <div class="swiper-wrapper">
                ${slidesHTML}
              </div>
            </div>
            <button class="dossha-upsell__nav dossha-upsell__nav--prev" aria-label="Geri" type="button">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <button class="dossha-upsell__nav dossha-upsell__nav--next" aria-label="İleri" type="button">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
            </button>
          </div>
        </div>`;
    }

    renderCard(product) {
      const imgSrc = product.images?.[0]
        ? dosshaImageResize(product.images[0], 400)
        : "";
      const url = `/products/${product.handle}`;
      const hasVariants =
        product.variants &&
        product.variants.length > 1 &&
        !product.has_only_default_variant;
      const firstAvailable =
        product.variants.find((v) => v.available) || product.variants[0];
      const price = firstAvailable.price;
      const comparePrice = firstAvailable.compare_at_price;
      const isOnSale = comparePrice && comparePrice > price;

      let priceHTML = `<span>${dosshaFormatMoney(price)}</span>`;
      if (isOnSale) {
        priceHTML = `<ins>${dosshaFormatMoney(price)}</ins><del>${dosshaFormatMoney(comparePrice)}</del>`;
      }

      let actionsHTML = "";
      if (hasVariants) {
        const anyAvailable = product.variants.some((v) => v.available);
        const firstAvailableVariant = product.variants.find((v) => v.available);

        const options = product.variants
          .map((v) => {
            const label = v.option3 || v.option2 || v.option1 || v.title;
            const isDisabled = !v.available;
            const isSelected = anyAvailable
              ? v.id === firstAvailableVariant.id
              : false;
            return `<option value="${v.id}"${isDisabled ? " disabled" : ""}${isSelected ? " selected" : ""}>${label}${isDisabled ? " - Tükendi" : ""}</option>`;
          })
          .join("");

        const soldOutOption = !anyAvailable
          ? "<option selected disabled>Tükendi</option>"
          : "";
        const selectDisabled = !anyAvailable ? " disabled" : "";
        const btnDisabled = !anyAvailable ? " disabled" : "";
        const btnVariant = anyAvailable
          ? ` data-variant-id="${firstAvailableVariant.id}"`
          : "";
        const btnText = anyAvailable ? "Sepete Ekle" : "Tükendi";

        actionsHTML = `
          <div class="dossha-upsell__select-wrap">
            <select class="dossha-upsell__select" data-product-handle="${product.handle}"${selectDisabled}>
              ${soldOutOption}${options}
            </select>
            <svg class="dossha-upsell__select-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </div>
          <button type="button" class="dossha-upsell__add-btn"${btnVariant} data-product-handle="${product.handle}"${btnDisabled}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span class="dossha-upsell__add-text">${btnText}</span>
          </button>`;
      } else {
        actionsHTML = `
          <button type="button" class="dossha-upsell__add-btn" data-variant-id="${firstAvailable.id}" data-product-handle="${product.handle}">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
            <span class="dossha-upsell__add-text">Sepete Ekle</span>
          </button>`;
      }

      return `
        <div class="swiper-slide dossha-upsell__card">
          <a href="${url}" class="dossha-upsell__card-link" tabindex="-1">
            <div class="dossha-upsell__card-img">
              ${imgSrc ? `<img src="${imgSrc}" alt="${product.title}" loading="lazy" width="400" height="533">` : ""}
            </div>
          </a>
          <div class="dossha-upsell__card-body">
            <a href="${url}" class="dossha-upsell__card-link">
              <h6 class="dossha-upsell__card-title">${product.title}</h6>
            </a>
            <div class="dossha-upsell__card-price">${priceHTML}</div>
            <div class="dossha-upsell__card-actions">${actionsHTML}</div>
          </div>
        </div>`;
    }

    initSwiper() {
      const swiperEl = this.querySelector(".dossha-upsell__swiper");
      if (!swiperEl || typeof Swiper === "undefined") return;

      this._swiperInstance = new Swiper(swiperEl, {
        slidesPerView: "auto",
        spaceBetween: 10,
        freeMode: {
          enabled: true,
          sticky: false,
        },
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector(".dossha-upsell__nav--prev"),
          nextEl: this.querySelector(".dossha-upsell__nav--next"),
        },
      });
    }

    bindAddButtons() {
      this.querySelectorAll(".dossha-upsell__select").forEach((select) => {
        select.addEventListener("change", () => {
          const card = select.closest(".dossha-upsell__card");
          const addBtn = card.querySelector(".dossha-upsell__add-btn");
          const selected = select.options[select.selectedIndex];
          if (selected && !selected.disabled) {
            addBtn.dataset.variantId = selected.value;
            addBtn.disabled = false;
          } else {
            addBtn.disabled = true;
          }
        });
      });

      this.querySelectorAll(".dossha-upsell__add-btn").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          const variantId = btn.dataset.variantId;
          if (!variantId) return;
          this.addToCart(variantId, btn);
        });
      });
    }

    async addToCart(variantId, btnEl) {
      btnEl.classList.add("is-loading");
      btnEl.disabled = true;

      try {
        const cartDrawer = document.querySelector("cart-drawer");
        const cartItems = document.querySelector("cart-items");
        const cartElement = cartDrawer || cartItems;

        let sectionsParam = [];
        if (
          cartElement &&
          typeof cartElement.getSectionsToRender === "function"
        ) {
          sectionsParam = cartElement
            .getSectionsToRender()
            .map((s) => s.section);
        }

        const formData = new FormData();
        formData.append("id", variantId);
        formData.append("quantity", "1");
        if (sectionsParam.length) {
          formData.append("sections", sectionsParam.join(","));
          formData.append("sections_url", window.location.pathname);
        }

        const response = await fetch(`${routes.cart_add_url}.js`, {
          method: "POST",
          headers: { "X-Requested-With": "XMLHttpRequest" },
          body: formData,
        });

        const result = await response.json();

        if (result.status === 422) {
          btnEl.classList.remove("is-loading");
          btnEl.disabled = false;
          return;
        }

        btnEl.classList.remove("is-loading");
        btnEl.classList.add("is-added");
        btnEl.querySelector(".dossha-upsell__add-text").textContent = "Eklendi";

        if (cartDrawer && result.sections) {
          cartDrawer.renderContents(result);
        } else if (cartItems && result.sections) {
          cartElement.getSectionsToRender()?.forEach((section) => {
            const el =
              document.querySelector(section.selector) ||
              document.querySelector(section.id);
            if (el && result.sections[section.section]) {
              el.innerHTML =
                new DOMParser()
                  .parseFromString(
                    result.sections[section.section],
                    "text/html",
                  )
                  .querySelector(section.selector)?.innerHTML || "";
            }
          });
        }

        if (typeof updateCartCounters === "function") updateCartCounters();
        if (typeof updateFreeShipping === "function") updateFreeShipping();
      } catch (error) {
        console.error("[DOSSHA Upsell] Add to cart failed:", error);
        btnEl.classList.remove("is-loading");
        btnEl.disabled = false;
      }
    }
  }

  customElements.define("dossha-cart-upsell", DosshaCartUpsell);
}
